<template>
  <div class="body-container stricken-passageway" v-if="isLoad" style="background:#507aff">
    <div class="panel">
      <img src="@static/images/exercise/phoneDoctor/z1.jpg" class="img" />
      <div class="content">
        <div class="box">
          <div>
            <img
              src="@static/images/exercise/phoneDoctor/head_bg.jpg"
              alt
              style="width:100%;display:block"
            />
          </div>
          <div class="table-box">
            <table>
              <thead class="tops">
                <tr>
                  <th>序号</th>
                  <th>服务项目</th>
                  <th>服务方式及次数</th>
                </tr>
              </thead>
              <tr class="d1" v-for="item in tableData" :key="item.id">
                <td class="first">{{item.id}}</td>
                <td class="center">{{item.name}}</td>
                <td
                  class="last"
                  :class="[item.color?'active_item':'']"
                  v-html="item.style"
                  v-if="!item.rowSpan&&!item.noTd"
                ></td>
                <td
                  class="last"
                  :class="[item.color?'active_item':'']"
                  v-html="item.style"
                  v-if="item.rowSpan&&!item.noTd"
                  rowspan="6"
                ></td>
              </tr>
            </table>
          </div>
          <!-- <div class="info-text">有效期：自开通日起1年</div> -->
        </div>
        <div class="imgBox">
          <img src="@static/images/exercise/phoneDoctor/z2.jpg" alt style="width:100%;display:block" />
        </div>
        <div class="imgBox imgBox02">
          <img src="@static/images/exercise/phoneDoctor/z3.jpg" alt style="width:100%;display:block" />
        </div>
        <div class="botL">
          <div class="listBtn" @click="openPDF">重疾绿通具体服务和医院列表></div>
        </div>
      </div>
    </div>

    <div class="bottom-box">
      <div class="money-box" v-if="data.id">
        <span class="money">￥{{Number(data.realMoney)}} 元</span>
        <span
          class="old oldMoney"
          v-if="data.realMoney != data.originalMoney"
        >原价￥{{Number(data.originalMoney)}} 元</span>
      </div>
      <div class="button" @click="submit">立即购买</div>
    </div>
  </div>
</template>
<script>
import loading from "@/components/commons/loading";
export default {
  data() {
    return {
      isLoad: false, //触发页面滚动到顶部
      id: "",
      tableData: [
        {
          id: 1,
          name: "远程问诊",
          style: "电话沟通，1次/年",
          color: true
        },
        {
          id: 2,
          name: "专家门诊",
          style: "分诊电话沟通，门诊线下安排，1次/年"
        },
        {
          id: 3,
          name: "住院安排",
          style: "此六项为打包服务;<br>线下安排，每项服务1次/年",
          color: true,
          rowSpan: true
        },
        {
          id: 4,
          name: "手术安排",
          noTd: true
        },
        {
          id: 5,
          name: "住院探访",
          noTd: true
        },
        {
          id: 6,
          name: "医后随访",
          noTd: true
        },
        {
          id: 7,
          name: "中医理疗",
          noTd: true
        },
        {
          id: 8,
          name: "营养方案",
          noTd: true
        },
        {
          id: 9,
          name: "专家复诊",
          style: "线下安排，1次/年"
        }
      ],
      data: {}
    };
  },
  methods: {
    openPDF() {
      var url = location.origin + "/m/resource/pdf/viewer.html?file=https://static.wts999.com//FILE/1249649752028454912/具体服务及医院列表.pdf";
      if (this.$tools.isWtsNativeApp()) {
        nativeApp.general.deviceready(function() {
          nativeApp.general.readPdf({
            url:"https://static.wts999.com//FILE/1249649752028454912/具体服务及医院列表.pdf",
            title: "重疾绿通服务详情介绍及具体医院网点"
          });
        });
        return;
      }
      location.href = url;
    },
    submit() {
      this.$router.push({
        path: "/addedService/strickenPay02",
        query: {
          id: this.id
        }
      });
    },
    getData() {
      this.$http({
        url: "/addedservices/upmarketServer/api/real/list"
      })
        .then(r => {
          r.data.forEach(item => {
            if (this.id == item.id) {
              this.data = item;
            }
          });
        })
        .catch(err => {});
    }
  },
  mounted() {
    window.setTimeout(_ => {
      this.isLoad = true;
    }, 200);
    this.id = this.$route.query.id;
    console.log(this.id);
    if (!this.id) {
      return;
    }
    this.getData();
    //行为上传
    this.$units.reportUp(this.$config.user,18,this.id,'访问重疾绿通');
  }
};
</script>

<style lang="scss" scoped>
@import "~@/sass/exercise/strickenPassageway";
.stricken-passageway {
  img{
    display: block;
  }
  .botL {
    margin-top: r(30);
    text-align: center;
    color: #fff;
    font-size: r(28);
    .listBtn {
      width: 60%;
      margin: 0 auto;
      padding: r(10) r(20);
      border-radius: r(40);
      box-shadow: inset  0 0 6px #ccc;
    }
  }
  .box:nth-child(1) {
    padding-top: 0;
  }
  .imgBox {
    margin-top: r(30);
    img {
      width: 99% !important;
      margin: 0 auto;
    }
  }
  .table-box {
    text-align: center;
    border-radius: 0;

    .tops {
      background: #5179ff;
      border-radius: 0;
      color: #fff;
      font-size: r(30);

      tr {
        th {
          text-align: center;
        }
      }
    }
    .active_item {
      background: #e4eaff;
    }
    .first {
      width: auto;
      padding-left: 0;
      padding-right: 0;
      width: 15%;
      text-align: center;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .center {
      width: 25%;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding-left: 0;
    }
    .last {
      width: auto;
      padding-left: r(10);
      padding-right: r(10);
      text-align: center;
      border-bottom: 1px solid #ccc;
    }
  }

  .box {
    background: #2f55d0;
    box-shadow: none;
  }
  .bottom-box {
    .button {
      background: #ff9e00;
    }
  }
}
</style>
